import axios from 'axios';

import { ERROR } from '../actions/appState';
import { storeUserProfile, userLogOut } from '../utils/AuthUtil';

export const LOGIN_API = Symbol('LOGIN API');
export const LOGOUT_API = Symbol('LOGOUT API');

function callApi(email: string, password: string, agencyId: number, idToken?: string, accessToken?: string) {
  let LOGIN_URL = '';
  let data = {};
  if (idToken) {
    LOGIN_URL = agencyId
      ? `${process.env.API_URL}/oauth/agencies/${agencyId}/login`
      : `${process.env.API_URL}/oauth/admin/login`; // for future use
    data = { idToken, accessToken };
  } else {
    LOGIN_URL = agencyId ? `${process.env.API_URL}/agencies/${agencyId}/login` : `${process.env.API_URL}/admin/login`;
    data = { email, password };
  }

  return axios
    .post(LOGIN_URL, data)
    .then((response: any) => {
      if (response.status !== 200) {
        throw Error(response.statusText);
      }

      return storeUserProfile(response.data.token);
    })
    .catch((error) => {
      throw error;
    });
}

export const LoginMiddleware = (store) => (next) => (action) => {
  const loginAPI = action[LOGIN_API];

  // So the middleware doesn't get applied to every single action
  if (typeof loginAPI === 'undefined') {
    return next(action);
  }

  const { email, password, agencyId, idToken, accessToken, types, errorDismissible } = loginAPI;

  // TODO
  // Use the ES6 format while implementing retries.
  // const [requestType, successType, errorType] = types;
  const successType = types[1];
  const errorType = types[2];

  return callApi(email, password, agencyId, idToken, accessToken).then(
    (response) =>
      next({
        userProfile: response,
        type: successType,
      }),
    (error) => {
      store.dispatch({
        type: ERROR,
        errorMessage: error.response.data.message,
        errorDismissible,
      });

      return next({
        error: error.message || 'There was an error.',
        serverError: error.response.data.message,
        type: errorType,
      });
    }
  );
};

export const LogOutMiddleware = (store) => (next) => (action) => {
  const logOutAPI = action[LOGOUT_API];

  // So the middleware doesn't get applied to every single action
  if (typeof logOutAPI === 'undefined') {
    return next(action);
  }

  userLogOut();

  return next({ type: 'LOGOUT_SUCCESS' });
};
